"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgEnvelopeSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M23.605 4.376c.25.42.395.91.395 1.433v12.255a2.814 2.814 0 01-2.809 2.808H2.81A2.814 2.814 0 010 18.064V5.809c0-.523.144-1.013.395-1.433l11.123 9.177.098.068c.27.157.615.134.865-.068zM21.191 3c.466 0 .906.114 1.293.317L12 11.972 1.516 3.317A2.786 2.786 0 012.81 3z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgEnvelopeSolid;
exports.default = _default;